import { LockOutlined } from "@ant-design/icons";
import { Radio, Tag } from "antd";
import { ComponentProps } from "react";
import { BuildingIcon } from "./BuildingIcon";
import { Flex } from "./Flex";
import { VzblIcon } from "./VzblIcon";

export function ResourceAccessRadioButtons({
  isAtLeastSuper,
  type,
  ...radioGroupProps
}: {
  isAtLeastSuper?: boolean;
  type: string;
} & ComponentProps<typeof Radio.Group>) {
  return (
    <Radio.Group {...radioGroupProps} style={{ display: "block" }}>
      <Flex direction="column" start style={{ width: "100%" }}>
        <Radio value="private" className="resource-access-radio-button">
          <span style={{ flex: 1 }}>Only you have access to this {type}</span>
          <Tag bordered={false} style={{ margin: 0 }}>
            <LockOutlined />
          </Tag>
        </Radio>
        <Radio value="workspace" className="resource-access-radio-button">
          <span style={{ flex: 1 }}>Share this {type} with your org</span>
          <Tag bordered={false} style={{ margin: 0 }}>
            <BuildingIcon size={12} />
          </Tag>
        </Radio>
        {isAtLeastSuper && (
          <Radio value="global" className="resource-access-radio-button">
            <span style={{ flex: 1 }}>Make this a global {type}</span>
            <Tag bordered={false} style={{ margin: 0 }}>
              <VzblIcon style={{ fill: "currentColor" }} size={12} />
            </Tag>
          </Radio>
        )}
      </Flex>
    </Radio.Group>
  );
}
